import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../../styles/MatchList.css';

const MatchTable = ({ filteredMatches }) => {
  const navigate = useNavigate();

  const handleMatchClick = (match) => {
    console.log("MatchTable.js: passed match data from MatchTable.js to AdminMatchDetails.js ", match);
    navigate(`/admin/matches/${match.matchid}/${match.date}`, { state: { matchData: match } });
  };


  return (
    <div>
      <table className="data-table">
        <thead>
          <tr>
            <th>Match</th>
          </tr>
        </thead>
        <tbody>
          {filteredMatches.map(match => (
            <tr
              key={`${match.matchid}-${match.date}`}
              onClick={() => handleMatchClick(match)}
              style={{ cursor: 'pointer' }}
            >
              <td style={{ textAlign: 'left' }} className="match-cell">
                <span className="match-date">{match.date}</span>
                <div className="teams-matchup">
                  <span className="team-name-1">{match.team_1_name}</span>
                  <span className="vs-separator">vs</span>
                  <span className="team-name-2">{match.team_2_name}</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatchTable;
